import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectionType, TableColumn } from '@swimlane/ngx-datatable';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

import { Client } from '../../../../portfolio/interfaces/client.interface';
import { ClientService } from '../../../../portfolio/services/client.service';
import { NgxDatatablePageEvent, NgxDatatableSelectionEvent } from 'src/app/model/interfaces/ngx-datatable';
import { QueryParams } from 'src/app/model/interfaces/request';
import { ApiResponse } from 'src/app/model/interfaces/response';
import {
  AutoconsumoCreacionMantenedorService
} from "../../../../autoconsumo/services/autoconsumo-creacion-mantenedor.service";

@Component({
  selector: 'app-cliente-modal',
  templateUrl: './cliente-modal.component.html',
  styleUrls: ['./cliente-modal.component.css']
})
export class ClienteModalComponent implements OnInit {

  columns: TableColumn[];
  itemsCounts = [25, 50, 100];
  pageSize = this.itemsCounts[0];
  SelectionType = SelectionType;
  selected = [];
  selection?: any;
  searchParamBehaviorSubject: BehaviorSubject<QueryParams<any>>;
  dataSource$: Observable<ApiResponse<any>>;

  formFilter: FormGroup;

  @ViewChild('btnCloseModal')
  elementBtnCloseModal: ElementRef<HTMLButtonElement>

  @Output()
  onSelect = new EventEmitter<any>();
  @Input()
  dataReference: string;

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _clientService: ClientService,
    private readonly  _autoconsumoCreacionMantenedorService: AutoconsumoCreacionMantenedorService
  ) {
    this.gridColumns();
    this.buildForm();
    this.searchParamBehaviorSubject = new BehaviorSubject({ page: 0, pageSize: this.itemsCounts[0] });
  }

  ngOnInit(): void {
    if(this.dataReference && this.dataReference === 'autoconsumo-cliente'){
      this.dataSource$ = this.searchParamBehaviorSubject
        .asObservable()
        .pipe(
          tap((queryParams)=> this._clientService.queryParams = {...queryParams}),
          switchMap((queryParams) => this._autoconsumoCreacionMantenedorService.getAll()),
        );
      this.formFilter.valueChanges
        .pipe(
          debounceTime(1000),
          distinctUntilChanged(),
        )
        .subscribe((formValue) => {
          this.searchParamBehaviorSubject.next({ [`${formValue.option}`]: formValue.filter, pageSize: formValue.itemsCount, page: 0 });
        });
    }else {
      this.dataSource$ = this.searchParamBehaviorSubject
        .asObservable()
        .pipe(
          tap((queryParams)=> this._clientService.queryParams = {...queryParams}),
          switchMap((queryParams) => this._clientService.findBy()),
        );
      this.formFilter.valueChanges
        .pipe(
          debounceTime(1000),
          distinctUntilChanged(),
        )
        .subscribe((formValue) => {
          this.searchParamBehaviorSubject.next({ [`${formValue.option}`]: formValue.filter, pageSize: formValue.itemsCount, page: 0 });
        });
    }
  }

  gridColumns() {
    if(this.dataReference && this.dataReference === 'autoconsumo-cliente'){
      this.columns = [
        {
          name: 'ID Cliente',
          prop: 'cliente.idCliente',
          width: 50,
          sortable: false,
          draggable: false,
          headerClass: 'fw-bold'
        },
        {
          name: 'Cliente',
          prop: 'cliente.nombreCliente1',
          width: 100,
          sortable: false,
          draggable: false,
          headerClass: 'fw-bold'
        },
        {
          name: 'RUC',
          prop: 'cliente.ruc',
          width: 300,
          sortable: false,
          draggable: false,
          headerClass: 'fw-bold'
        }
      ];
    }else {
      this.columns = [
        {
          name: 'ID Cliente',
          prop: 'idCliente',
          width: 50,
          sortable: false,
          draggable: false,
          headerClass: 'fw-bold'
        },
        {
          name: 'Cliente',
          prop: 'nombreCliente1',
          width: 100,
          sortable: false,
          draggable: false,
          headerClass: 'fw-bold'
        },
        {
          name: 'RUC',
          prop: 'ruc',
          width: 300,
          sortable: false,
          draggable: false,
          headerClass: 'fw-bold'
        }
      ];
    }
  }

  buildForm() {
    this.formFilter = this._formBuilder.group({
      filter: [''],
      option: [this.columns[0].prop],
      itemsCount: [this.itemsCounts[0]],
      orderItems: [false]
    });
  }

  onSelectRow($event: NgxDatatableSelectionEvent<any>) {
    this.selection = $event.selected[0];
  }

  accept() {
    this.onSelect.emit(this.selection);
    this.elementBtnCloseModal.nativeElement.click();
  }

  setPage($event: NgxDatatablePageEvent) {
    this.searchParamBehaviorSubject.next({
      ...this.searchParamBehaviorSubject.value,
      page: $event.offset,
      pageSize: $event.limit
    });
  }

}
